import { render, staticRenderFns } from "./addMaterialB2c.vue?vue&type=template&id=3c0e2dcd"
import script from "./addMaterialB2c.vue?vue&type=script&lang=js"
export * from "./addMaterialB2c.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports